import { env } from "../../../env";
import ChatAIWS from "../../ia/ChatAIWS";
import { Dashed } from "./Dashed/Dashed";

export const DefaultHome = () => {
    const useIA = env.USE_IA ?? false;





    return useIA ? <ChatAIWS Structure="MenuLogin"  /> : <Dashed />
}